import {Redirect} from 'react-router-dom'
import {useAuthValue} from '../src/Components/AuthContext'
import React from 'react';

export default function PrivateRoute({children}) {
  const {currentUser} = useAuthValue()
  
  if(!currentUser?.getIdToken()){
    return <Redirect to='/login' replace/>
  }
  return children
}